/*
 * @Description: 
 * @Author: ywj
 * @Date: 2025-02-13 10:07:54
 * @LastEditTime: 2025-03-03 09:48:01
 * @LastEditors: ywj@originqc.com
 */
import React from 'react'
import CustomTitle from '@/components/custom-title'
import GoMore from '@/components/more'
import Card from '@/components/card'
import { goodsLink } from '@/views/home/config'
import './index.scss';

interface IMini{
 goodsData:any,
 data:any
}
const MiniGoods: React.FC<IMini> = (props) => {
  const { goodsData, data } = props;

  return (
    <section className='goods-chain'>
    <div className="goods-top">
      <CustomTitle title={data?.name} /><GoMore  data={ data}/>
    </div>
    <div className="card-box">
      {(goodsData?.length>8?goodsData?.slice(0,8):goodsData)?.map((item:any) => {
        return (              
          <React.Fragment key={item.id}>
              <Card {...item} width={295}  is_list="home"/>
          </React.Fragment>
          
        )
      })}
    </div>
  </section>
  )
}

export default MiniGoods;